{
  "cabin": {
    "mixed": "All classes"
  }
}
